import c from 'classnames';
import { shuffle } from 'lodash';
import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import quotes from '../utils/quotes';

const Wrapper = tw.div`flex`;
const Container = tw.div`self-center m-auto`;
const quotesShuffled = shuffle(quotes);
interface Props {
    full?: boolean;
    small?: boolean;
}

export default function Loader({ full = false, small = false }: Props) {
    const [quote, setQuote] = useState<{ quote: string; author?: string }>();
    useEffect(() => {
        if (full && !small) {
            setQuote(quotesShuffled[0]);
        }
    }, [full, small]);
    return (
        <Wrapper className={c({ 'h-screen w-full': full })}>
            <Container>
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 100 100"
                    enableBackground="new 0 0 0 0"
                    xmlSpace="preserve"
                    className={c('mx-auto fill-current', { 'w-6': small, 'w-24': !small })}
                >
                    <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform
                            attributeName="transform"
                            attributeType="XML"
                            type="rotate"
                            dur="1s"
                            from="0 50 50"
                            to="360 50 50"
                            repeatCount="indefinite"
                        />
                    </path>
                </svg>
                {quote && (
                    <div className="px-4 text-sm text-center text-gray-600 flex-col mx-auto max-w-md">
                        <div>{quote.quote}</div>
                        {quote.author && <div className="italic">{quote.author}</div>}
                    </div>
                )}
            </Container>
        </Wrapper>
    );
}
